import { getDocs, getDoc, collection, doc } from "firebase/firestore";
import React, { useCallback, useEffect, useState } from "react";

const ShowAllOrders = ({ db }) => {
  const [orders, setAllOrders] = useState(null);
  const [tastingNotes, setTastingNotes] = useState(null);
  const [wines, setWines] = useState(null);

  const fetchOrders = useCallback(async () => {
    let orders = [];
    const querySnapshot = await getDocs(collection(db, "orders"));
    querySnapshot.forEach((doc) => {
      orders.push({ ...doc.data(), id: doc.id });
    });
    setAllOrders(
      orders.sort((a, b) => b.placedOn.seconds - a.placedOn.seconds)
    );
    // console.log("orders:", orders);
  }, [db]);

  const fetchWines = useCallback(async () => {
    let wines = [];
    const querySnapshot = await getDocs(collection(db, "wines"));
    querySnapshot.forEach((doc) => {
      wines.push(doc.data());
    });
    setWines(wines);
  }, [db]);

  const fetchTastingNotes = useCallback(async () => {
    const docRef = doc(db, "tastingNotes", "Xm6PBat6Jmq9Ap2ckA2d");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setTastingNotes(docSnap.data().collection);
    } else {
      // console.log("No such document!");
    }
  }, [db]);

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);
  // useEffect(() => {
  //   fetchWines();
  // }, [fetchWines]);
  // useEffect(() => {
  //   fetchTastingNotes();
  // }, [fetchTastingNotes]);

  // useEffect(() => {
  //   getFilteredData();
  // }, [orders, tastingNotes, wines]);

  const getFilteredData = (list) => {
    // const cartItems = list.filter((wine) =>
    //   Object.keys(cart).includes(wine.name)
    // );
  };

  return (
    <div>
      {orders && (
        <table>
          <thead>
            <tr style={{ width: "100%" }} key="heading">
              <th style={{ width: "10%" }}>TOKEN</th>
              <th>Name</th>
              <th>Email</th>
              <th style={{ width: "30%" }}>Product Name | Quantity | Retail</th>
              <th style={{ width: "30%" }}>Time</th>
            </tr>
          </thead>
          <tbody>
            {orders.map(({ id, name, email, cart, placedOn }) => (
              <tr key={id}>
                {/* {console.log("fdsafdsafsda", placedOn)} */}
                <td>{id}</td>
                <td>{name}</td>
                <td>{email}</td>
                {Object.keys(cart).map((key, index) => (
                  <tr key={index}>
                    <td>{key}</td>
                    <td>{cart[key].count}</td>
                    <td>{cart[key].retail}</td>
                  </tr>
                ))}
                <td>
                  {new Date(placedOn.seconds * 1000).toDateString()} ||{" "}
                  {new Date(placedOn.seconds * 1000).toTimeString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ShowAllOrders;
